export default "__VITE_ASSET__486be4f2__"